export function BalanceRing({ used, balance, size = 80, label }) {
  const pct    = balance > 0 ? Math.max(0, Math.min(1, (balance - used) / balance)) : 0;
  const r      = size / 2 - 8;
  const circ   = 2 * Math.PI * r;
  const dash   = pct * circ;
  const cx     = size / 2;
  const stroke = pct > 0.4 ? '#6FCF97' : pct > 0.2 ? '#F5A300' : '#FF8A80';

  return (
    <div style={{ position: 'relative', width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)', position: 'absolute' }}>
        <circle cx={cx} cy={cx} r={r} fill="none" stroke="var(--track)" strokeWidth="6" />
        <circle cx={cx} cy={cx} r={r} fill="none" stroke={stroke} strokeWidth="6"
          strokeLinecap="round" strokeDasharray={`${dash} ${circ}`}
          style={{ transition: 'stroke-dasharray 0.6s ease' }}
        />
      </svg>
      <div style={{ textAlign: 'center', position: 'relative' }}>
        <div style={{ fontSize: size * 0.22, fontWeight: 600, color: 'var(--text)', lineHeight: 1, fontFamily: "'Rubik', 'DM Sans', sans-serif" }}>
          {label ?? '—'}
        </div>
        <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 2 }}>left</div>
      </div>
    </div>
  );
}